import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class UserRegisterBySocialVerification extends Event {
    eventName = 'oms_userRegisterBySocialVerification';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for User Register
     * 
     * @param {string} data.name -  name of the customer
     * @param {string} data.email -  email of the customer
     * @param {string} data.calling_code -  calling code of the customer
     * @param {string} data.contact_number -  contact number of the customer
     * @param {string} data.verification_id -  more info (custom fields) of the customer
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.UserRegisterBySocialVerification;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            name: data.name,
            email: data.email,
            calling_code: data.calling_code,
            contact_number: data.contact_number,
            verification_id: data.verification_id,
            otp: data.otp ? data.otp : null,
            otp_request_id: data.otp_request_id ? data.otp_request_id : null,
        };

        // send request
        this.sendRequest(data, function (response) {
          if (response) {
            //format response data
            let data = thisObj.formatResponseData(response);

            if (data.success && data.data.access_token) {
                //add data to storage
                let userDetails = new LocalStorage.UserDetails(clientId);
                userDetails.setData(response);
                
                //set auth requesting variable to null - so new access token value can be retriveved from promise
                window.ajaxAuthRequest = null;
            }

            //fire success event
            thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
          }
        });

    }
}

export default UserRegisterBySocialVerification;
